import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const fetchChallengesForGroupRequest = createAction('fetchChallengesForGroupRequest');
export const fetchChallengesForGroupSuccess = createAction<Challenge[]>(
    'fetchChallengesForGroupSuccess',
);
export const fetchChallengesForGroupFailure = createAction('fetchChallengesForGroupFailure');

export const fetchChallengesForGroup = (challengeGroupID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchChallengesForGroupRequest());
    try {
        const { data } = await api.get<Challenge[]>('admin/challenges/group/' + challengeGroupID);
        dispatch(fetchChallengesForGroupSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengesForGroupFailure, e);
    }
};
